// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-btn {
    border: none;
    padding: 5px 0px;
    border-radius: 10px;
    background-color: rgba(25, 118, 210, 1);
    color: white;
}

.student-box {
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
}

.about-input {
    width: 100%;
    padding: 10px;
    border-radius: 10px;
    
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: none;
    margin: 10px 0;
}


.about-input:focus , .about-input:active {
    border: 1px solid rgba(0, 0, 0, 0.25) !important;
    outline: none
}

.edit-icon {
    position: absolute;
    top: 25px;
    left: 30px;
}

.student-box{
    position: relative;
   
}

.b-green{
     width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/styles/about.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;;IAEnB,qCAAqC;IACrC,aAAa;IACb,cAAc;AAClB;;;AAGA;IACI,gDAAgD;IAChD;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;KACK,YAAY;AACjB","sourcesContent":[".upload-btn {\n    border: none;\n    padding: 5px 0px;\n    border-radius: 10px;\n    background-color: rgba(25, 118, 210, 1);\n    color: white;\n}\n\n.student-box {\n    background-color: white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n    border-radius: 20px;\n}\n\n.about-input {\n    width: 100%;\n    padding: 10px;\n    border-radius: 10px;\n    \n    border: 1px solid rgba(0, 0, 0, 0.25);\n    outline: none;\n    margin: 10px 0;\n}\n\n\n.about-input:focus , .about-input:active {\n    border: 1px solid rgba(0, 0, 0, 0.25) !important;\n    outline: none\n}\n\n.edit-icon {\n    position: absolute;\n    top: 25px;\n    left: 30px;\n}\n\n.student-box{\n    position: relative;\n   \n}\n\n.b-green{\n     width: 180px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
